import type { IDomainValidForSegments } from "app/pages/segments/wizard/SegmentFirstStep/SegmentCreationFirstStep";
import { hasSegmentsClaim } from "app/pages/segments/config/segmentsConfigHelpers";

interface SelectableState {
    selectable: boolean;
    reasonKey?: string;
}

const selectableStateBuilder = (selectable, reasonKey = null) => {
    return { selectable, reasonKey };
};
export const resolveSelectableState = (domainValidForSegments: IDomainValidForSegments): SelectableState => {
    if (!domainValidForSegments) {
        return selectableStateBuilder(false);
    }
    if (!hasSegmentsClaim()) {
        return selectableStateBuilder(false, "folders.analysis.table.segment.not.selectable.due.to.claim");
    }
    const blockedDueToMetering = false;
    if (blockedDueToMetering) {
        return selectableStateBuilder(false, "folders.analysis.table.segment.not.selectable.due.to.metering");
    }
    const { isBlacklisted } = domainValidForSegments;
    if (isBlacklisted) {
        return selectableStateBuilder(false, "folders.analysis.table.segment.not.selectable.due.to.black.list");
    }
    return { selectable: true };
};
